import Rx from 'rx';

export default function MemberGyslCtrl($scope, $wamp, observeOnScope, progressBar) {

  let reportsSubscription = Rx.Observable.fromPromise($wamp.call('org.eggs.gysl'))
      .safeApply($scope, function (reports) {
        $scope.reports = reports;
      }).subscribe();

  let reportItemsSubscription = observeOnScope($scope, 'report')
      .map(function (change) {
        return change.newValue;
      })
      .filter(function (report) {
        return report;
      })
      .do(function (report) {
        $scope.items = [];
        progressBar.add("gysl");
      })
      .flatMap(function (report) {
        return $wamp.call(report.uri);
      })
      .safeApply($scope, function (items) {
        progressBar.remove("gysl");
        $scope.items = items;
      }).subscribe();

  $scope.$on('$destroy', function () {
    reportsSubscription.dispose();
    reportItemsSubscription.dispose();
  });
}